import { render, staticRenderFns } from "./PaymentDetails.vue?vue&type=template&id=49c8b4e8&scoped=true&"
import script from "./PaymentDetails.vue?vue&type=script&lang=js&"
export * from "./PaymentDetails.vue?vue&type=script&lang=js&"
import style0 from "./PaymentDetails.vue?vue&type=style&index=0&id=49c8b4e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c8b4e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49c8b4e8')) {
      api.createRecord('49c8b4e8', component.options)
    } else {
      api.reload('49c8b4e8', component.options)
    }
    module.hot.accept("./PaymentDetails.vue?vue&type=template&id=49c8b4e8&scoped=true&", function () {
      api.rerender('49c8b4e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PaymentDetails.vue"
export default component.exports